import { memo } from 'react';

interface GlassLoaderProps {
  label?: string;
  subLabel?: string;
}

function GlassLoader({ label = 'Loading…', subLabel }: GlassLoaderProps) {
  return (
    <div className="absolute inset-0 z-50 flex items-center justify-center">
      <div className="pointer-events-none select-none rounded-2xl border border-white/20 bg-white/10 px-8 py-6 backdrop-blur-xl shadow-[0_20px_40px_rgba(0,0,0,0.5)]">
        <div className="flex flex-col items-center gap-4">
          <svg
            className="h-8 w-8 text-white animate-spin"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
            <path
              className="opacity-75"
              d="M22 12a10 10 0 0 1-10 10"
              stroke="currentColor"
              strokeWidth="4"
              strokeLinecap="round"
            />
          </svg>
          <div className="flex flex-col items-center gap-1">
            <span className="text-base font-semibold text-white">{label}</span>
            {subLabel && (
              <span className="text-xs text-white/80">{subLabel}</span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default memo(GlassLoader);


